export default [{
	header: 'Solicitudes',
	icon: 'FileTextIcon',
	children: [		
		{
			title: 'Lista',
			route: 'requests-list',
			icon: 'ListIcon',
			action: 'read',
			resource: 'requests'
		},
		{
			title: 'Nuevo',
			route: 'requests-create',
			icon: 'PlusSquareIcon',
			action: 'create',
			resource: 'requests'
		},
	]
}];